import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    
    fetchEmployeeProfile: builder.mutation({
      query: () => ({
        url: `/profile/employee/profile/`,
        method: 'GET'
      }),
    }),
    // updateEmployeeProfile: builder.mutation({
    //   query: ({ user_id, data }) => ({
    //     url: `/profile/employee/profile/${user_id}`,
    //     method: "PUT",
    //     data,
    //   }),
    // }),
    updateEmployeeProfile: builder.mutation({
      query: ({ data }) => ({
        url: `/profile/employee/profile/`,
        method: "PUT",
        data,
      }),
    }),
    
    registerEmployee: builder.mutation({
      query: (data) => ({
        url: "profile/employee/register",
        method: "POST",
        data,
      }),
    }),
    createOrganizations: builder.mutation({
      query: (data) => ({
        url: "profile/add/organizations",
        method: "POST",
        data,
      }),
    }),
    createManager: builder.mutation({
      query: (data) => ({
          url: "profile/add/managers",
          method: 'POST',
          data,
        }),
    }),
    fetchManagers: builder.query({
        query: () => ({
          url: "profile/managers",
          method: 'GET'
        }),
      }),
    fetchCurrentUser: builder.query({
        query: (userId) => ({
          url: `profile/current-user/${userId}`,
          method: 'GET'
        }),
      }),
    fetchOrganizations: builder.query({
        query: () => ({
            url: "profile/organizations",
            method: 'GET'
          }),
      }),
      fetchManagersByOrg: builder.query({
        query: (org_id) => ({
          url: `/profile/organizations/${org_id}/managers`,
          method: 'GET'
        }),
      }),
      createEmployee: builder.mutation({
        query: (data) => ({
          url: '/profile/add/employee',  // Update with the correct endpoint for creating an employee
          method: 'POST',
          data,
        }),
      }),
      resendEmail: builder.mutation({
        query: (userID) => ({
          url: `/profile/resendEmail/${userID}`,  // Update with the correct endpoint for creating an employee
          method: 'POST',
         
        }),
      }),
      completeRegistration: builder.mutation({
        query: (data) => ({
          url: '/profile/complete-registration',
          method: 'POST',
          data,
        }),
      }),
      updateUser: builder.mutation({
        query: (data) => ({
          url: '/profile/update-user-details',
          method: 'PUT',
          data,
        }),
      }),
      fetchOrgName: builder.query({
        query: () => ({
          url: `/profile/get-organization-name`,
          method: 'GET'
        }),
      }),
      fetchOrgData: builder.query({
        query: (organizationID) => ({
          url: `/profile/organizations/${organizationID}`,
          method: 'GET'
        }),
      }),
      
      updateOrganization: builder.mutation({
        query: ({ organizationID, data }) => ({
          url: `/profile/organizations/${organizationID}`,
          method: "PUT",
          data: data, // Send the actual form data in the request body
        }),
      }),
      
      resetPassOrg: builder.mutation({
        query: ({ orgId, data }) => ({
          url: `profile/organizations/${orgId}/reset-password`,
          method: "PUT",
          data: data, // Send the actual form data in the request body
        }),
      }),
      generateFormLink: builder.mutation({
        query: (data) => ({
          url: "/profile/generateFormLink",
          method: "POST",
          data  // Should contain `{ email: user.email }`
        }),
      }),
      
    
    
    
  }),
});

// Export hooks for usage in functional components
export const {
  useFetchEmployeeProfileMutation,
  useUpdateEmployeeProfileMutation,
  useRegisterEmployeeMutation,
  useFetchManagersQuery,
  useFetchOrganizationsQuery,
  useFetchCurrentUserQuery,
  useCreateManagerMutation,
  useCreateOrganizationsMutation,
  useFetchManagersByOrgQuery,
  useCreateEmployeeMutation,
  useCompleteRegistrationMutation,
  useResendEmailMutation,
  useUpdateUserMutation,
  useFetchOrgNameQuery,
  useFetchOrgDataQuery,
  useUpdateOrganizationMutation,
  useResetPassOrgMutation,
  useGenerateFormLinkMutation
  

} = profileApi;

export default profileApi;